<template>
<div
    v-bind:class="{ 
        'chip': true, 
        'chip_open' : value == 'open', 
        'chip_void' : value == 'void', 
        'chip_ready' : value =='ready-to-process' ,
        'chip_processed_success' : value == 'processed-success',
        'chip_processed_failed' : value == 'processed-error',
    }"
>
    {{label}}
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: function() { return 'open'; }
        },
    },

    computed: {
        label() {
            if ( this.value == 'open' ) return 'OPEN';
            if ( this.value == 'void' ) return 'VOID';
            if ( this.value == 'ready-to-process' ) return 'PROCESS';
            if ( this.value == 'processed-success' ) return 'PROCESSED';
            if ( this.value == 'processed-error' ) return 'FAILED';
            
            return 'UNKNOWN';
        }
    },
}
</script>

<style lang="scss" scoped>

.chip {
    font-size: 12px;
    border-radius: 5px;
    width: 100px;
    text-align: center;
}

.chip_open {
    border: 1px solid rgba(50,50,255,0.75);
    color:rgba(50,50,255,0.75);
}

.chip_void {
    border: 1px solid rgba(50,50,50,0.75);
    color:rgba(50,50,50,0.75);
}

.chip_ready {
    border: 1px solid rgb(255, 150, 0);
    color:rgb(255, 150, 0);
}

.chip_processed_success {
    border: 1px solid rgba(0,200,0,1);
    color:rgba(0,200,0,1);
}

.chip_processed_failed {
    border: 1px solid rgba(200,0,0,1);
    color:rgba(200,0,0,1);
}


</style>